/* Depmall Poster theme behaviours. No dependencies; Dawn globals used when present. */
(function () {
  'use strict';

  var store = {
    get: function (k, s) { try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } },
    set: function (k, v, s) { try { (s ? sessionStorage : localStorage).setItem(k, v); } catch (e) { /* storage blocked */ } }
  };

  function checkoutUrl() {
    return (window.dpSettings && window.dpSettings.checkoutUrl) || '/pages/checkout';
  }

  function moneyGEL(tetri) {
    var v = (Number(tetri) || 0) / 100;
    return v.toFixed(2) + ' ₾';
  }

  /* ---------- chat ---------- */
  function initChat() {
    var root = document.querySelector('[data-dp-chat]');
    if (!root) return;
    var btn = root.querySelector('[data-dp-chat-toggle]');
    var menu = root.querySelector('.dp-chat__menu');
    function set(open) {
      root.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (menu) menu.hidden = !open;
    }
    btn.addEventListener('click', function () { set(!root.classList.contains('is-open')); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) set(false); });
  }

  /* ---------- cookie consent (Shopify Customer Privacy API; shows only where consent is required) ---------- */
  function initCookie() {
    var box = document.querySelector('[data-dp-cookie]');
    if (!box || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err || !window.Shopify.customerPrivacy) return;
      var cp = window.Shopify.customerPrivacy;
      var show = typeof cp.shouldShowBanner === 'function' ? cp.shouldShowBanner() : false;
      if (!show) return;
      box.classList.add('is-visible');
      box.querySelector('[data-dp-cookie-accept]').addEventListener('click', function () {
        cp.setTrackingConsent({ analytics: true, marketing: true, preferences: true, sale_of_data: true }, function () {
          box.classList.remove('is-visible');
        });
      });
    });
  }

  /* ---------- cart reminder toast ---------- */
  function initReminder() {
    var box = document.querySelector('[data-dp-reminder]');
    if (!box) return;
    var path = window.location.pathname;
    if (/\/cart\/?$/.test(path) || path.indexOf('/pages/checkout') !== -1 || path.indexOf('/pages/order-') !== -1) return;
    if (store.get('dp_reminder_seen', true)) return;
    var delay = (Number(box.dataset.delay) || 10) * 1000;
    setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.items || !cart.items.length) return;
          var item = cart.items[0];
          var text = box.querySelector('[data-dp-reminder-text]');
          var tpl = text.dataset.template || '';
          var strong = document.createElement('strong');
          strong.textContent = item.product_title;
          var parts = tpl.split('{product_title}');
          text.textContent = '';
          text.appendChild(document.createTextNode(parts[0] || ''));
          text.appendChild(strong);
          text.appendChild(document.createTextNode(parts.slice(1).join('{product_title}')));
          var img = box.querySelector('[data-dp-reminder-img]');
          if (item.image) { img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=128'; } else { img.remove(); }
          box.hidden = false;
          store.set('dp_reminder_seen', '1', true);
          box.querySelector('[data-dp-reminder-close]').addEventListener('click', function () { box.hidden = true; });
          setTimeout(function () { box.hidden = true; }, 10000);
        })
        .catch(function () {});
    }, delay);
  }

  /* ---------- before / after ---------- */
  function initCompare(scope) {
    (scope || document).querySelectorAll('[data-dp-compare]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var range = el.querySelector('input[type="range"]');
      function upd() { el.style.setProperty('--pos', range.value + '%'); }
      range.addEventListener('input', upd);
      upd();
    });
  }

  /* ---------- countdown ---------- */
  function initCountdown(scope) {
    (scope || document).querySelectorAll('[data-dp-countdown]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var mode = el.dataset.mode || 'daily';
      var offsetMin = Number(el.dataset.tzOffset || 240);
      var fixed = el.dataset.deadline ? Date.parse(el.dataset.deadline) : NaN;
      var cells = {
        d: el.querySelector('[data-unit="d"]'), h: el.querySelector('[data-unit="h"]'),
        m: el.querySelector('[data-unit="m"]'), s: el.querySelector('[data-unit="s"]')
      };
      function target(now) {
        if (mode === 'date' && !isNaN(fixed)) return fixed;
        var local = new Date(now + offsetMin * 60000);
        var end = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate() + 1) - offsetMin * 60000;
        return end;
      }
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var now = Date.now();
        var diff = Math.max(0, target(now) - now);
        var s = Math.floor(diff / 1000);
        cells.d.textContent = pad(Math.floor(s / 86400));
        cells.h.textContent = pad(Math.floor((s % 86400) / 3600));
        cells.m.textContent = pad(Math.floor((s % 3600) / 60));
        cells.s.textContent = pad(s % 60);
        if (diff === 0 && mode === 'date') { el.closest('.dp-cd') && el.closest('.dp-cd').setAttribute('data-expired', ''); return; }
        setTimeout(tick, 1000 - (now % 1000));
      }
      tick();
    });
  }

  /* ---------- FAQ search ---------- */
  function initFaqSearch(scope) {
    (scope || document).querySelectorAll('[data-dp-faq-search]').forEach(function (input) {
      if (input.dataset.ready) return;
      input.dataset.ready = '1';
      var list = document.getElementById(input.getAttribute('aria-controls'));
      if (!list) return;
      var empty = list.querySelector('.dp-faq-empty');
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var shown = 0;
        list.querySelectorAll('details').forEach(function (d) {
          var hit = !q || d.textContent.toLowerCase().indexOf(q) !== -1;
          d.hidden = !hit;
          if (hit) shown++;
        });
        if (empty) empty.style.display = shown ? 'none' : 'block';
      });
    });
  }

  /* ---------- review clamp ---------- */
  function initReviewMore(scope) {
    (scope || document).querySelectorAll('[data-dp-more]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      var item = btn.closest('.dp-rev__item');
      var quote = item && item.querySelector('blockquote');
      if (!quote) return;
      requestAnimationFrame(function () {
        if (quote.scrollHeight <= quote.clientHeight + 2) btn.hidden = true;
      });
      btn.addEventListener('click', function () {
        var clamped = item.classList.toggle('is-clamped');
        btn.textContent = clamped ? btn.dataset.more : btn.dataset.less;
        btn.setAttribute('aria-expanded', clamped ? 'false' : 'true');
      });
    });
  }

  /* ---------- quantity offer (same contract as the previous theme: quantity input + LUMIVEA2 / IBORIA2 handled at checkout) ---------- */
  if (!customElements.get('depmall-quantity-offer')) {
    customElements.define('depmall-quantity-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.productForm = document.getElementById(this.dataset.productFormId || '');
        this.quantityInput = this.querySelector('[data-depmall-offer-quantity-input]');
        this.addEventListener('change', (e) => {
          if (!e.target.matches('[data-quantity-choice]')) return;
          var q = parseInt(e.target.value, 10) || 1;
          if (this.quantityInput) {
            this.quantityInput.value = String(q);
            this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          this.syncSticky(q);
        });
        var checked = this.querySelector('[data-quantity-choice]:checked');
        this.syncSticky(checked ? parseInt(checked.value, 10) : 1);
      }
      syncSticky(q) {
        var sticky = document.querySelector('[data-dp-sticky-price]');
        if (!sticky) return;
        var opt = this.querySelector('[data-quantity-choice][value="' + q + '"]');
        if (opt && opt.dataset.totalLabel) sticky.textContent = opt.dataset.totalLabel;
      }
    });
  }

  /* ---------- installment purchase: add current selection, go to the store checkout page ---------- */
  function initInstallment() {
    document.addEventListener('click', async function (e) {
      var button = e.target.closest('[data-dp-installment]');
      if (!button) return;
      e.preventDefault();
      if (button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      try {
        var productInfo = button.closest('product-info') || document.querySelector('product-info');
        var form = document.getElementById(button.dataset.productFormId || '');
        var variantInput = form && form.querySelector('input[name="id"]');
        var selectedVariantScript = productInfo && productInfo.querySelector('variant-selects [data-selected-variant]');
        var selectedVariant = selectedVariantScript && selectedVariantScript.textContent.trim() ? JSON.parse(selectedVariantScript.textContent) : null;
        var variantId = Number((variantInput && variantInput.value) || (selectedVariant && selectedVariant.id) || button.dataset.defaultVariantId);
        var variantPrice = Number((selectedVariant && selectedVariant.price) || button.dataset.defaultVariantPrice || 0);
        if (!variantId) throw new Error('Missing product variant id.');
        var qtyInput = (productInfo && productInfo.querySelector('[data-depmall-offer-quantity-input]')) || (form && document.querySelector('input[name="quantity"][form="' + form.id + '"]'));
        var quantity = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
        var offer = productInfo && productInfo.querySelector('depmall-quantity-offer');
        var expectedUnit = Number(offer ? offer.dataset.expectedUnitTetri : 0);
        var offerTotal = quantity === 2 && variantPrice === expectedUnit ? Number(offer.dataset.offerTotalTetri || 0) : 0;

        var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
        var existing = cart.items.find(function (it) { return it.variant_id === variantId; });
        if (existing) {
          await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: existing.key, quantity: quantity }) });
        } else {
          var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: quantity }) });
          if (!res.ok) throw new Error('add failed');
        }
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'AddToCart', { content_type: 'product', currency: 'GEL', value: (offerTotal || variantPrice * quantity) / 100, content_ids: [variantId], num_items: quantity });
        }
        window.location.href = checkoutUrl();
      } catch (err) {
        button.removeAttribute('aria-busy');
        var msg = button.parentElement.querySelector('[data-dp-installment-error]');
        if (msg) { msg.hidden = false; }
      }
    });
  }

  /* ---------- quick add for poster lists (ranked list, versus) ---------- */
  function initQuickAdd() {
    document.addEventListener('click', async function (e) {
      var btn = e.target.closest('[data-dp-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      var label = btn.innerHTML;
      try {
        var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = { items: [{ id: Number(btn.dataset.dpAdd), quantity: 1 }] };
        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || 'error');
        if (cartEl && typeof cartEl.renderContents === 'function') {
          var item = data.items ? data.items[0] : data;
          item.sections = data.sections;
          if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
          cartEl.renderContents(item);
        } else {
          window.location.href = '/cart';
        }
        if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'dp-quick-add' });
      } catch (err) {
        btn.innerHTML = btn.dataset.errorLabel || label;
        setTimeout(function () { btn.innerHTML = label; }, 2500);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  }

  /* ---------- bundle (frequently bought together) ---------- */
  function initBundle(scope) {
    (scope || document).querySelectorAll('[data-dp-bundle]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var discount = Number(root.dataset.discountTetri || 0);
      var code = root.dataset.discountCode || '';
      var sumEl = root.querySelector('[data-bundle-sum]');
      var wasEl = root.querySelector('[data-bundle-was]');
      var saveEl = root.querySelector('[data-bundle-save]');
      var btn = root.querySelector('[data-bundle-add]');
      var msg = root.querySelector('[data-bundle-msg]');
      function checked() { return Array.prototype.filter.call(root.querySelectorAll('input[data-bundle-item]'), function (i) { return i.checked && !i.disabled; }); }
      function calc() {
        var items = checked();
        var total = items.reduce(function (t, i) { return t + Number(i.dataset.price || 0); }, 0);
        var all = items.length === root.querySelectorAll('input[data-bundle-item]:not(:disabled)').length && items.length > 1;
        var disc = all ? Math.min(discount, total) : 0;
        sumEl.textContent = moneyGEL(total - disc);
        wasEl.textContent = disc > 0 ? moneyGEL(total) : '';
        wasEl.hidden = !(disc > 0);
        saveEl.textContent = disc > 0 ? (saveEl.dataset.label || '').replace('[amount]', (disc / 100).toFixed(2)) : '';
        saveEl.hidden = !(disc > 0);
        btn.disabled = items.length === 0;
        return { items: items, applyCode: all && disc > 0 && code };
      }
      root.addEventListener('change', calc);
      calc();
      btn.addEventListener('click', async function () {
        var st = calc();
        if (!st.items.length) return;
        btn.setAttribute('aria-busy', 'true');
        try {
          var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: st.items.map(function (i) { return { id: Number(i.value), quantity: 1 }; }) }) });
          if (!res.ok) throw new Error('add');
          if (st.applyCode) {
            await fetch('/discount/' + encodeURIComponent(st.applyCode), { method: 'GET', headers: { 'X-Requested-With': 'XMLHttpRequest' } }).catch(function () {});
          }
          window.location.href = '/cart';
        } catch (e) {
          if (msg) msg.textContent = msg.dataset.error || '';
          btn.removeAttribute('aria-busy');
        }
      });
    });
  }

  /* ---------- sticky add to cart ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-dp-sticky]');
    if (!bar) return;
    var anchor = document.querySelector(bar.dataset.anchor || '.product-form__buttons');
    if (!anchor) return;
    document.body.classList.add('dp-has-sticky');
    var ticking = false;
    var footer = document.querySelector('.dp-footer');
    function update() {
      ticking = false;
      var passed = anchor.getBoundingClientRect().bottom < 0;
      var atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      bar.classList.toggle('is-visible', passed && !atFooter);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- cart attribute "how did you hear about us" ---------- */
  function initCartAttr() {
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-dp-attr]');
      if (!sel) return;
      var key = sel.dataset.dpAttr;
      var other = sel.parentElement.querySelector('[data-dp-attr-other]');
      var isOther = sel.value === sel.dataset.otherValue;
      if (other) other.hidden = !isOther;
      if (!isOther) save(key, sel.value);
    });
    var t;
    document.addEventListener('input', function (e) {
      var inp = e.target.closest('[data-dp-attr-other]');
      if (!inp) return;
      clearTimeout(t);
      t = setTimeout(function () { save(inp.dataset.key, inp.value); }, 500);
    });
    function save(key, val) {
      var attrs = {}; attrs[key] = val;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
    }
  }

  /* ---------- lazy looping videos ---------- */
  function initLazyVideo(scope) {
    var vids = (scope || document).querySelectorAll('video[data-dp-lazy-video]:not([data-ready])');
    if (!vids.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var load = function (v) {
      v.dataset.ready = '1';
      v.src = v.dataset.src;
      if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.controls = true; }
    };
    if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); load(en.target); } });
    }, { rootMargin: '200px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  function initAll(scope) {
    initLazyVideo(scope);
    initCompare(scope);
    initCountdown(scope);
    initFaqSearch(scope);
    initReviewMore(scope);
    initBundle(scope);
  }

  function boot() {
    initAll(document);
    initChat();
    initCookie();
    initReminder();
    initInstallment();
    initQuickAdd();
    initSticky();
    initCartAttr();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
